/** Favicon and install icons declared in the root head. Files live in apps/web/public (built by scripts/brand/build-brand.mjs). */
export const brandIconLinks = [
  // The ico is sized 32x32 so Chrome prefers the SVG (which follows the dark/light tab theme); browsers without SVG favicons use the ico (indigo ground).
  { rel: "icon", href: "/favicon.ico", sizes: "32x32" },
  { rel: "icon", href: "/favicon.svg", type: "image/svg+xml" },
  { rel: "apple-touch-icon", href: "/apple-touch-icon.png", sizes: "180x180" },
  { rel: "manifest", href: "/site.webmanifest" },
] as const

/** Matches `primary` in packages/design-tokens (light) and the manifest theme_color. */
export const brandThemeColor = "#3b46f1"
/** Dark-mode `primary` token, for the dark theme-color. */
export const brandThemeColorDark = "#7c84ff"
